import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// The single-target edit. Enforces the legal-transition matrix server-side and
// rejects "not-entered" outright — removal is CSV-only.
export const updateMembershipStatus = async (cycleId, userId, status) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.put(
    `/awards-service-api/admin/cycles/${cycleId}/memberships/${userId}`,
    { status },
    { headers },
  );

  return response.data;
};
